import { useState } from "react";
import SrNoWiseItemHistoryList from "../srNoWiseItemHistory/SrNoWiseItemHistoryList"
import Modal from "../../../components/generics/Modal";

const TyreReportPopup = ({ handleModal, selectedItemDetails }) => {
    const [loadData, setLoadData] = useState(true);

    const handleClose = () => {
        setLoadData(false);
        handleModal();
    };

    return (
        <div className="tyre--report--modal">
            <Modal
                updateModal={handleModal}
                isModal={true}
                headTxt={`Detail Report for Serial No: ${selectedItemDetails.searchSerialNo}`}
            >
                <div className="tyre--modal--content jc--scroll" >
                    <SrNoWiseItemHistoryList
                        srNoWiseItemHistoryFilters={selectedItemDetails}
                        loadData={loadData}
                        setLoadData={setLoadData}
                        onClose={handleClose} />
                </div>
            </Modal>
        </div>
    );
};
export default TyreReportPopup;